// "Sos parte" recién cuando tenés un depósito aprobado: al menos un acuerdo aprobado,
// o que ya fue aprobado y hoy está completado.
export const hasApprovedAgreement = (agreements) =>
    (agreements || []).some(a => a.status === 'aprobado' || a.status === 'completado');
